import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { isMobile } from "../../../helpers";
import { Menu, Layout, Avatar, Badge } from "antd";
import { CarOutlined, UserOutlined, UsergroupAddOutlined, NotificationOutlined, PullRequestOutlined } from '@ant-design/icons';
import logoWhite from "../../../assets/img/logo/araciste-logo.png"
import store from "../../../store";

const { Header } = Layout;

const menus = [
  {
    key: "1",
    name: "Araç Talebi",
    route: "/app/trips",
    icon: <CarOutlined />,
    isDefault: true,
    items: [
      {
        key: "0",
        name: "Yönetici Onayları",
        isDefault: false,
        route: "/app/tripunitapprovals",
        type: "unitApprovalBadge"
      },
      {
        key: "1",
        name: "Talep Onayları",
        isDefault: false,
        route: "/app/tripapprovals",
        type: "approvalBadge"
      },
      {
        key: "2",
        name: "Talep Listesi",
        isDefault: true,
        route: "/app/trips"
      },
      {
        key: "3",
        name: "Yeni Talep",
        isDefault: false,
        route: "/app/trips/create"

      }
    ]
  },
  {
    key: "2",
    name: "Adresler",
    route: "/app/addresses",
    icon: <PullRequestOutlined />,
    isDefault: false,
    items: [
      {
        key: "1",
        name: "ADRESLER",
        isDefault: true,
        route: "/app/addresses",
      },
      {
        key: "2",
        name: "ADRES EKLE",
        isDefault: false,
        route: "/app/addresses/create"
      }
    ]
  },
  {
    key: "3",
    name: "Kişiler",
    route: "/app/contacts",
    icon: <UsergroupAddOutlined />,
    isDefault: false,
    items: [{
      key: "1",
      name: "Kişi Listesi",
      route: "/app/contacts",
      isDefault: true,
    },
    {
      key: "2",
      name: "Kişi Ekle",
      route: "/app/contacts/create",
      isDefault: false,
    }
    ]
  },
  {
    key: "4",
    name: "Profil",
    route: "/app/accounts",
    icon: <UserOutlined />,
    isDefault: false,
    items: [
      {
        key: "1",
        name: "Profil Bilgileri",
        route: "/app/accounts/profile",
        isDefault: true
      },
      {
        key: "2",
        name: "Ayarlar",
        route: "/app/accounts/settings",
        isDefault: false
      },
      {
        key: "3",
        route: "/app/accounts/change-password",
        name: "Şifre Değiştirme",
        isDefault: false
      },
      {
        key: "4",
        route: "/app/accounts/dashboard",
        name: "Yönetim Paneli",
        isDefault: false
      },
      {
        key: "5",
        name: "Çıkış",
        route: "/app/accounts/logout",
        isDefault: false
      }
    ]
  },
  {
    key: "5",
    name: "Bildirimler",
    route: "/app/notifications",
    icon: <UserOutlined />,
    isDefault: false,
    isVisible: false,
    items: [
      {
        key: "1",
        name: "Bildirimler",
        route: "/app/notifications",
        isDefault: true
      }
    ]
  },
]


class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isResponsive: false,
      account: props.account,
      selectedMenuKey: null,
      selectedSubMenuKey: null
    };
    this.unsubscribe = store.subscribe(() => {
      this.setState({ account: store.getState().auth.account })
    });
  }


  componentWillMount() {

    isMobile() && this.setState({ isResponsive: true });

    var splitUrl = this.props.location.pathname.split("/");
    var menuUrl = `/${splitUrl[1]}/${splitUrl[2]}`

    if (menuUrl === "/app/tripapprovals") {
      menuUrl = "/app/trips"
    }

    if (menuUrl === "/app/tripunitapprovals") {
      menuUrl = "/app/trips"
    }

    var menu = menus.find(x => x.route === menuUrl);

    if (menu) {

      this.setState({ selectedMenuKey: menu.key }, () => {

        var defaultSubMenu = menu.items.find(x => x.route === this.props.location.pathname);

        if (defaultSubMenu) {
          this.setState({ selectedMenuKey: menu.key, selectedSubMenuKey: defaultSubMenu.key })
        }
        else if (this.props.location.pathname.includes("/app/contacts/")) {
          this.setState({ selectedSubMenuKey: null })
        }
        else if (!this.state.selectedSubMenuKey) {
          defaultSubMenu = menu.items.find(x => x.isDefault);
          this.setState({ selectedMenuKey: menu.key, selectedSubMenuKey: defaultSubMenu.key })
        }
      })
    }
  }

  subMenus = () => {

    let { account } = this.state;

    var menu = menus.find(x => x.key === this.state.selectedMenuKey);

    var subMenus = [];

    if (menu) {

      if (menu.key === "4") {

        if (account.role === "SystemAdministrator" || account.role === "AdministrativeManager" || account.isCostCenterApprover ) {
          
        }else{
          menu.items = menu.items.filter(x => x.key !== "4");
        }

      }

      subMenus = menu.items.map((item) => {
        return (
          item.type === "approvalBadge" ?


            <Menu.Item key={item.key}
              icon={this.state.account.costApprovalCount > 0 && <Badge count={this.state.account.costApprovalCount} style={{ color: "#fff", borderColor: "#faad14", backgroundColor: "#faad14" }} />}

            > {item.name}
            </Menu.Item >



            : item.type === "unitApprovalBadge" ?

              <Menu.Item key={item.key}
                icon={this.state.account.pendingApprovalCount > 0 && <Badge count={this.state.account.pendingApprovalCount} style={{ color: "#fff", borderColor: "#faad14", backgroundColor: "#faad14" }} />}
              > {item.name}
              </Menu.Item >

              :

              <Menu.Item key={item.key}>
                {item.name}
              </Menu.Item >
        );
      })
    }



    return subMenus;

  }

  onSelectMenu = (item) => {

    var menu = menus.find(x => x.key === item.key);
    let defaultSubMenu = menu.items.find(x => x.isDefault);

    this.setState({ selectedMenuKey: item.key, selectedSubMenuKey: defaultSubMenu.key })

    this.props.history.push(
      menu.route
    );

  }

  onSelectSubMenu = (item) => {

    var menu = menus.find(x => x.key === this.state.selectedMenuKey);
    let defaultSubMenu = menu.items.find(x => x.key === item.key);

    this.setState({ selectedSubMenuKey: defaultSubMenu.key })

    this.props.history.push(
      defaultSubMenu.route
    );
  }

  render() {

    let { selectedMenuKey, selectedSubMenuKey, account } = this.state;

    return (
      <Fragment>
        <Header className="ant-layout-header-menu">
          <div className="logo-container"
            onClick={() => this.props.history.push(
              `/app/trips`
            )}
          >
            <img alt="Logo" className="logo" src={logoWhite} />
          </div>
          <Menu mode="horizontal" selectedKeys={[selectedMenuKey]} onClick={(e) => this.onSelectMenu(e)}>
            {menus.map((menu) =>

              menu.key === "4" && account.picturePath ?
                <Menu.Item icon={<Avatar
                  src={account.picturePath}
                  size={27}
                >
                </Avatar>} key={menu.key}>{menu.name}</Menu.Item>
                : menu.key === "5" ?
                  <Menu.Item className="notification" icon={<NotificationOutlined />} key={menu.key}>

                    <Badge
                      count={account.unreadNotificationsCount}
                      style={{ backgroundColor: '#32a852', borderColor: "#32a852", width: 26, height: 26, borderRadius: "50%", lineHeight: "26px" }}
                    >
                    </Badge>
                  </Menu.Item>
                  :
                  <Menu.Item icon={menu.icon} key={menu.key} >{menu.name}</Menu.Item>
            )}




          </Menu>
        </Header>
        {
          account && account.role &&

          <Header className="ant-layout-header-sub-menu">
            <Menu mode="horizontal" selectedKeys={[selectedSubMenuKey]} onClick={(e) => this.onSelectSubMenu(e)}>
              {this.subMenus()}
            </Menu>
          </Header>
        }
      </Fragment >
    );
  }
}

const mapStateToProps = ({ auth, notification }) => ({ ...auth, ...notification });
export default withRouter(connect(mapStateToProps)(Navbar));



// WEBPACK FOOTER //
// ./src/components/App/Layout/Navbar.js